import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import CT from '@marketplace-ai/tags';
import { useState } from 'react';
import { Button } from '~/components/buttons/Button/Button';

const DETAIL_TAGS = CT.employer.contracts.contractDetail;

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

export const TerminationDialog = ({ open, onClose, onConfirm }: Props) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm(reason);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-grey-100/60 backdrop-blur-sm transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />
      <div className="fixed inset-0 z-10 flex items-center justify-center p-4">
        <DialogPanel
          transition
          className="bg-white p-6 rounded-xl shadow-xl max-w-md w-full max-h-[calc(100dvh-2rem)] overflow-y-auto max-sm:[overflow-wrap:anywhere] transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:data-closed:translate-y-0 sm:data-closed:scale-95"
        >
          <DialogTitle className="text-lg font-semibold text-grey-100 mb-2">
            Request Termination
          </DialogTitle>
          <p className="text-sm text-grey-500 mb-4">
            This will send a termination request to support, who will review it, and let the other
            party know it was requested. The contract status will not change until support processes
            the request.
          </p>
          <label htmlFor="termination-reason" className="sr-only">
            Termination reason
          </label>
          <div className="mb-4">
            <textarea
              id="termination-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="block w-full border border-grey-800 rounded-md p-3 text-sm resize-none transition-colors duration-150 focus:border-primary-50 focus:ring-3 focus:ring-primary-50/12 focus:outline-none placeholder:text-grey-600"
              rows={3}
              placeholder="Please provide a reason for the termination request..."
              data-cy={DETAIL_TAGS.terminationReason}
            />
            {!reason.trim() && (
              <p className="text-xs text-grey-500 mt-1">A reason is required to submit.</p>
            )}
          </div>
          <div className="flex flex-col sm:flex-row sm:justify-end gap-3">
            <Button wrap colorVariant="secondary" onClick={onClose} label="Cancel" type="button" />
            <Button
              wrap
              colorVariant="error"
              onClick={handleConfirm}
              disabled={!reason.trim()}
              label="Request Termination"
              type="button"
            />
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
